/**
 * One top-level facet group (value, badge, or philanthropy). Checkboxes, OR within group.
 */
import React from "react";

export default function MListTopFacetGroup({ title, options, selectedIds, onChange, ariaLabel }) {
  const handleToggle = (id) => {
    const next = selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id];
    onChange(next);
  };

  return (
    <div className="twentytwentysix-content__mlist-facet-group" role="group" aria-label={ariaLabel || title}>
      <span className="twentytwentysix-content__mlist-facet-group-title">{title}</span>
      <div className="twentytwentysix-content__mlist-facet-options">
        {options.map((opt) => (
          <label key={opt.id} className="twentytwentysix-content__mlist-facet-option">
            <input
              type="checkbox"
              checked={selectedIds.includes(opt.id)}
              onChange={() => handleToggle(opt.id)}
              aria-checked={selectedIds.includes(opt.id)}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
